import { Navigate, Outlet } from 'react-router';

import { LoadingOverlay, LoadingOverlayLabel, LoadingOverlaySpinner } from '@/components/ui/loading-overlay';
import { useQuizBuilder } from '@/context/quiz-builder';

export default function QuizBuilderLayout() {
  const { quizQuery } = useQuizBuilder();

  if (quizQuery.isError) {
    return <Navigate to={'/manage/quizzes'} />;
  }
  return (
    <div className="base-direction-col h-full overflow-hidden">
      <div className="bg-background viewport-height relative flex w-full flex-col overflow-hidden rounded-2xl border">
        {/* dim + spinner overlay */}
        <LoadingOverlay isLoading={quizQuery.isPending} className="rounded-2xl">
          <LoadingOverlaySpinner />
          <LoadingOverlayLabel>Ładowanie danych...</LoadingOverlayLabel>
        </LoadingOverlay>
        <Outlet />
      </div>
    </div>
  );
}
